import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { key: { type: String, default: 'artgym-rebrand-banner-dismissed' } }

  connect() {
    if (localStorage.getItem(this.keyValue) === 'true') {
      this.element.remove()
    }
  }

  dismiss() {
    localStorage.setItem(this.keyValue, 'true')
    this.element.remove()
  }
}
